<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.99822 0L15.7252 7.1326C16.0597 7.44132 15.8412 8 15.3861 8H13.3322V16H9.99886V11.1667C9.99886 10.8905 9.775 10.6667 9.49886 10.6667H6.49886C6.22272 10.6667 5.99886 10.8905 5.99886 11.1667V16H2.66553V8H0.610382C0.155227 8 -0.0632087 7.44132 0.271241 7.1326L7.99822 0Z"
  />
</template>
